// import './wdyr';
import * as serviceWorker from './serviceWorker';
import './i18n';
import {retry} from './utils/commonFunctions';

import firebase from 'firebase/app';
import {Suspense, lazy, StrictMode} from 'react';
import {render} from 'react-dom';
import {BrowserRouter as Router} from 'react-router-dom';
import 'firebase/analytics';

const App = lazy(() => retry(() => import('./App')));
const rootElement = document.getElementById('root');

const firebaseConfig = {
  apiKey: 'AIzaSyD-sPsY0Y5jZBGhS9uuLqOWrNVLWvHBPjg',
  authDomain: 'neural-geode-744.firebaseapp.com',
  databaseURL: 'https://neural-geode-744.firebaseio.com',
  projectId: 'neural-geode-744',
  storageBucket: 'neural-geode-744.appspot.com',
  messagingSenderId: '574497742376',
  appId: '1:574497742376:web:72264ce0294e3af83fdf1d',
  measurementId: 'G-WG8EGFRMNR',
};
// initialize firebase
firebase.initializeApp(firebaseConfig);

const main = () =>
  render(
    <Suspense fallback={<div />}>
      <Router basename="/covid19india-react">
        <StrictMode>
          <App />
        </StrictMode>
      </Router>
    </Suspense>,
    rootElement
  );

const browserSupportsAllFeatures = () => {
  return window.requestIdleCallback && window.IntersectionObserver;
};

const loadScript = (src, done) => {
  const js = document.createElement('script');
  js.src = src;
  js.onload = function () {
    done();
  };
  js.onerror = function () {
    done(new Error('Failed to load script ' + src));
  };
  document.head.appendChild(js);
};

if (browserSupportsAllFeatures()) {
  main();
} else {
  loadScript(
    'https://polyfill.io/v3/polyfill.min.js?version=3.52.1&features=requestIdleCallback%2CIntersectionObserver',
    main
  );
}

serviceWorker.register();
